import React from "react";
import PopUp, { closePopUp } from "../../components/popUp";
import Button from "../../components/button";

interface SuccessPopUpProps {
    message: string;
}

export default function SuccessPopUp(props: SuccessPopUpProps) {
    return <PopUp title="Success">
        <p>{props.message}</p>
        <Button onClick={() => {
            window.location.href = "/logout";
        }}>Close</Button>
    </PopUp>
}